export class CloseRecomModel {
    id: number
    userId: number
}